import { AlertModal } from 'app/common/modals/alert'
import { Recaptcha } from 'app/common/recaptcha'
import { useEffect, useState } from 'react'
import type { DeviceCheck } from 'shared/types'
import { errors } from 'shared/utils'

let recaptchaPromise: Promise<string>
let resolve: any
let reject: any

const initRecaptchaPromise = () => {
    recaptchaPromise = new Promise((resolvePromise, rejectPromise) => {
        resolve = resolvePromise
        reject = rejectPromise
    })
}

const verifyCallback = (recaptchaToken: string) => {
    if (recaptchaToken) {
        resolve(recaptchaToken)
    } else {
        reject(new Error('Error getting recaptcha token'))
    }
}

type Props = {
    id?: string,
    token?: string,
    cancelOrderModal: boolean,
    setCancelOrderModal: (value: boolean) => void,
    cancelOrder: (
        id: string,
        token: string,
        deviceCheckPayload: DeviceCheck
    ) => void,
    setError: (value?: string) => void
}

export const CancelOrderModal = ({
    id,
    token,
    cancelOrderModal,
    setCancelOrderModal,
    cancelOrder,
    setError
}: Props) => {
    const [showCaptcha, setShowCaptcha] = useState(false)

    useEffect(() => {
        initRecaptchaPromise()
    }, [])

    const cancelMyOrder = async () => {
        if (id && token) {
            let errorMessage = undefined
            try {
                setShowCaptcha(true)
                const recaptchaToken = await recaptchaPromise
                const deviceCheckPayload = { queen: recaptchaToken }
                await cancelOrder(id, token, deviceCheckPayload)
            } catch (error) {
                switch (error) {
                    case errors.NETWORK:
                        errorMessage = 'error.network.alert.message'
                        break
                    default:
                        errorMessage = 'form.error.default'
                        break
                }
            } finally {
                setShowCaptcha(false)
                setError(errorMessage)
                initRecaptchaPromise()
            }
        }
    }

    return (
        <>
            {showCaptcha && (
                <Recaptcha
                    action="WebOrderStatusCard"
                    verifyCallback={verifyCallback}
                />
            )}
            {!!cancelOrderModal && (
                <AlertModal
                    alertTitleKey="clickandcollect.order.cancel.title"
                    alertContentKey="clickandcollect.order.cancel.question"
                    isOpen={!!cancelOrderModal}
                    handleClose={() => setCancelOrderModal(false)}
                    leftLabel="no"
                    onLeftClick={() => setCancelOrderModal(false)}
                    okLabel="yes.sure"
                    onOkClick={async () => {
                        setCancelOrderModal(false)
                        await cancelMyOrder()
                    }}
                />
            )}
        </>
    )
}
